/**
 * T139 — Nachträglich warning component.
 *
 * Displayed on the expense detail page when `nachträglich=true`.
 */
export function NachträglichWarning() {
  return (
    <div className="bg-amber-500/10 border border-amber-500/30 text-amber-100 px-3 py-2 rounded text-sm">
      ⚠️ <strong>Nachträglicher Beleg</strong>: Dieses Dokument liegt in einem
      bereits abgeschlossenen Quartal. Der Steuerberater wurde automatisch
      benachrichtigt.
    </div>
  );
}
